import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getGameProviderGameTypeList } from '../../services'
import {
	GameProviderWithBannerListResponse,
	GetGameProviderListRequest,
} from '@/modules/game/type'
import { GameQueryKeys } from '@/modules/game/keys'

export default function useQueryGetGameProviderGameTypeList(
	payload: GetGameProviderListRequest,
	props?: UseBaseQueryOptions<GameProviderWithBannerListResponse>,
) {
	return useQuery({
		queryKey: [GameQueryKeys.GetGameProviderList, payload],
		queryFn: () => getGameProviderGameTypeList(payload),
		...props,
	})
}
